import React from "react"
import { Link } from "gatsby"

export const Card = (props) => {
    return (
        <Link className={'mystery-card ' + props.mystery.frontmatter.title.toLowerCase()} to={'/mysteries' + props.mystery.fields.slug}>
            <h4>{props.mystery.frontmatter.title} Mysteries</h4>
        </Link>
    )
}